import { axios } from 'utils/networkRequests';

export const scheduler = {
  publishDrafts: (draftJobIds: number[]) =>
    axios.post(`/v3/facility/jobs/publish`, { job_ids: draftJobIds }),
  clearDrafts: (draftJobIds: number[]) =>
    axios.delete(`/v3/facility/jobs/discard`, { data: { job_ids: draftJobIds } }),
};
